const map = {
	"./APPLEPAY.png": 337,
	"./Amex.png": 790,
	"./Benefit.png": 510,
	"./Cliq.png": 784,
	"./Credit.png": 804,
	"./Credit0.png": 14,
	"./Credit1.png": 815,
	"./Fawry.png": 746,
	"./GOOGLEPAY.png": 550,
	"./GOOGLEPLAY.png": 92,
	"./KNET.png": 647,
	"./MADA.png": 392,
	"./MASTER.png": 849,
	"./MediaWorld.png": 291,
	"./Pointcheckout.png": 229,
	"./Primotech.png": 992,
	"./PrimotechOld.png": 853,
	"./Qicard.png": 935,
	"./Tabby.png": 149,
	"./Tasdeed.png": 793,
	"./VISA.png": 132,
	"./Zaincash.png": 640,
	"./directpay.png": 84,
	"./efawateercom.png": 714
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;